<template>
  <transition
    :css="false"
    appear
    mode="out-in"
    @enter="enter"
    @leave="leave">
    <aside
      v-if="current"
      :key="current.id"
      :class="[
        'the-notifications',
        { '-paused': paused },
      ]"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave">
      <span v-html="current.content" />

      <base-button
        v-if="current.actionLabel"
        :label="current.actionLabel"
        mode="secondary-outlined"
        light
        class="the-notifications__action"
        @click="handleAction">
        {{ current.actionLabel }}
      </base-button>

      <button
        v-if="!current.selfClosing"
        class="the-notifications__close"
        @click="removeCurrent">
        <base-icon name="close" />
      </button>
    </aside>
  </transition>
</template>

<script setup>
  import { enter, leave } from '~/animations/notification'

  const { bus } = useNuxtApp()
  const store = useNotificationsStore()
  const paused = ref(false)

  const current = computed(() => store.items[0])

  const removeCurrent = () => {
    store.items.shift()
  }

  const {
    pause, resume, restart
  } = usePausableTimeout(() => {
    removeCurrent()
  }, store.closeTime)

  watch(() => current.value?.id, () => {
    if (current.value?.selfClosing) {
      restart()
    }
  }, { immediate: true })

  const handleMouseEnter = () => {
    paused.value = current.value?.selfClosing ?? false
    if (current.value?.selfClosing) { pause() }
  }

  const handleMouseLeave = () => {
    paused.value = false
    if (current.value?.selfClosing) { resume() }
  }

  const handleAction = () => {
    if (current.value?.selfClosing) { removeCurrent() }
    bus.emit('notification:action')
  }
</script>

<style lang="scss" scoped>
  .the-notifications {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 600px;
    padding: 20px 30px;
    color: var(--color-bg);
    background-color: var(--color-dark);
    z-index: 30;
    filter: drop-shadow(2px 2px 8px rgba(var(--color-dark), 0.15));

    &::after {
      content: "";
      position: absolute;
      left: calc(100% - 15px);
      top: 0;
      bottom: 0;
      width: 35px;
      transform: skewX(20deg);
      background-color: var(--color-dark);
      z-index: -1;
    }

    > span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    @include mq(desktop) {
      gap: 15px;

      @include body-s;
    }

    &__action {
      flex: none;
      padding: 12px;
      font-size: 12px !important;
    }

    &__close {
      padding: 10px;
      padding-right: 0;
    }
  }
</style>
